import { loading, onboarding, toast, user } from "../types";
import { takeEvery, call, put, delay } from 'redux-saga/effects';
import api from "../apis";
import lambdas from "../lambdas/apis"


export function* resetOnboardingStore(action) {
    yield put({ type: onboarding.RESET_ONBOARDING_STORE_SUCCESS })
}

export function* getCustomerOnboardingStatus(action) {

    try {
        const response = yield call(api.user.getCustomerStatus, {});
        if (response.data.code === 200) {
            yield put({ type: onboarding.CUSTOMER_ONBOARDING_STATUS_SUCCESS, payload: response.data.data })
        } else if (response.data.code === 400) {
            let data = {
                is_pending: false
            }
            yield put({ type: onboarding.CUSTOMER_ONBOARDING_STATUS_SUCCESS, payload: data })
        } else {
            yield put({ type: onboarding.CUSTOMER_ONBOARDING_STATUS_FAILURE, payload: { message: 'Oops Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: onboarding.CUSTOMER_ONBOARDING_STATUS_FAILURE, payload: error })
    }
}



export function* saveCustomerOnboardingDetails(action) {
    
    const { userDetails, formdata, navigate, setGtag } = action.payload;
    const formValues = {
        "first_name":formdata?.first_name,
        "last_name":formdata?.last_name,
        "email":formdata?.email,
        "company_name":`${formdata?.first_name}${formdata?.last_name}`,
        "address":formdata?.address || "",
        "state":"1",
        "portal": "HORIZON",
        "document_type" : 0,
        "pincode" : 123456
    }

    let data = { ...formValues }
    try {
        const response = yield call(lambdas.user.onboardUser, {}, { role: userDetails.role.id }, {}, data);
        if (response.data.code === 201) {
            yield put({ type: onboarding.SAVE_CUSTOMER_ONBOARDING_DETAILS_SUCCESS, payload: response.data.customer })
                yield delay(1000)
			yield put({type: toast.SEND_TOAST , payload : {status : "success" , message: "User registration successful"}})
            yield put({type: user.USER_PROFILE_REQUEST})
    setGtag && setGtag('new-user-onboard');
            navigate("/service")
        } else {
            yield put({ type: onboarding.SAVE_CUSTOMER_ONBOARDING_DETAILS_FAILURE, payload: { message: 'Oops Something went wrong' } })
        }
        yield put({ type: toast.SEND_TOAST, payload: {status: 'danger', message: response.data.data.message} })
    } catch (error) {
        yield put({ type: onboarding.SAVE_CUSTOMER_ONBOARDING_DETAILS_FAILURE, payload: error })
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: {formName:"otpForm" , isLoading: false} })
}




export default function* onboardingSaga() {
    yield takeEvery(onboarding.RESET_ONBOARDING_STORE_REQUEST, resetOnboardingStore)
	yield takeEvery(onboarding.CUSTOMER_ONBOARDING_STATUS_REQUEST, getCustomerOnboardingStatus)
    yield takeEvery(onboarding.SAVE_CUSTOMER_ONBOARDING_DETAILS_REQUEST, saveCustomerOnboardingDetails)
}
